<template>
  <div class="gift-page main-block">
    <div class="white-box action-page">
      <div :class="{ gray: sex.isMan }" class="action-page--heading">
        <div class="set-flex set-flex-x-between">
          <h1 class="action-page--heading__h set-flex set-flex-y-center">
            <span>
              {{ $t('actionPages.titles.gifts') }}
            </span>
          </h1>
          <div v-if="!searchBy" class="action-page--tip">
            <form class="orders-search set-flex set-flex-y-center" @submit.prevent="">
              <div class="icon">
                <span class="rbi rbi-filter" />
              </div>
              <div class="form-group">
                <input
                  v-model="searchName"
                  :placeholder="$t('shared.placeholders.nameId')"
                  class="form-control"
                  type="text"
                />
              </div>
              <div class="form-group">
                <multiselect
                  v-model="searchType"
                  :allow-empty="false"
                  :options="options"
                  :searchable="false"
                  :show-labels="false"
                  label="v"
                  track-by="k"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <tabs
        v-if="sex.isMan"
        :options="{ useUrlFragment: false }"
        cache-lifetime="0"
        @changed="tabChanged"
      >
        <tab id="my" :name="titleMy">
          <div class="action-page--grid received_gifts_grid">
            <div class="d-flex justify-content-end align-items-center">
              <p
                class="d-none d-sm-block mb-2 text--underline"
                @click="markViewed(false, true, true, true, true)"
              >
                Mark all as viewed
              </p>
            </div>

            <div class="received_gifts">
              <div
                v-for="(gift, index) in myGifts"
                :key="`gift-my-${index}`"
                class="received_gift-col"
              >
                <div
                  :class="{ 'not-viewed': !gift.virtual_gift_sent.seen }"
                  class="received_gift"
                  @mouseenter="
                    markViewed(
                      gift.virtual_gift_sent.id,
                      false,
                      !gift.virtual_gift_sent.seen,
                      gift.virtual_gift_sent
                    )
                  "
                >
                  <div class="gift_sender">
                    <div class="wrap_img">
                      <img
                        :src="gift.sender_profile.avatar_url_list.small"
                        alt="gift.sender_profile.name"
                      />
                    </div>
                    <div class="wrap_receiv">
                      <p class="name_receiv">
                        {{ gift.sender_profile.name }}, ID:
                        {{ gift.sender_profile.user_id }}
                      </p>
                      <span class="time_create">{{
                        displayDate(gift.virtual_gift_sent.created_at)
                      }}</span>
                    </div>
                  </div>
                  <div class="gift_wrapper">
                    <div class="gift_photo">
                      <img :src="gift.virtual_gift.photo" alt="" />
                    </div>
                    <div class="comment">
                      <p>{{ gift.virtual_gift_sent.comment }}</p>
                    </div>
                  </div>
                  <rb-button
                    class="btn-black"
                    @click.native="previewSendGift(true, gift.sender_profile.user_id)"
                  >
                    Send a gift
                  </rb-button>
                </div>
              </div>

              <div
                v-show="displayLoadMoreBtn2"
                class="load-more btn btn-primary transparent btn-lazy-load"
                @click="loadMore"
              >
                {{ $t('shared.btn.lazyLoad', [20]) }}
              </div>
            </div>
          </div>
        </tab>

        <tab id="me" :name="titleMe">
          <div class="action-page--grid">
            <template v-if="!preloadPage && displayedGifts.length">
              <div v-if="!preloadPage" class="order-table--wrap">
                <table class="order-table gift-table">
                  <tr
                    v-if="gifts.length > 0"
                    class="d-none d-lg-table-row visible-lg order-table--header order-table--row"
                  >
                    <td class="order-table--cell order-table--header__cell small-cell hidden-xs">
                      <div class="relative">
                        {{ $t('actionPages.utils.serialNumber') }}
                        <button class="btn-sort" type="button" @click="sortBySerial">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td
                      class="order-table--cell order-table--header__cell large-extra-cell hidden-xs"
                    >
                      <div class="relative">
                        {{ $t('actionPages.utils.gift') }}
                        <button class="btn-sort" type="button" @click="sortByName">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td class="order-table--cell order-table--header__cell hidden-xs small-cell">
                      <div class="relative">
                        {{ $t('actionPages.utils.price') }}
                        <button class="btn-sort" type="button" @click="sortByPrice">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td class="order-table--cell order-table--header__cell hidden-xs small-cell">
                      <div class="relative">
                        {{ $t('actionPages.utils.quantityS') }}
                        <button class="btn-sort" type="button" @click="sortByQuantity">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td
                      class="order-table--cell order-table--header__cell responsive-width bdtop-l small-cell"
                    >
                      <div class="relative">
                        {{ $t('actionPages.utils.sum') }}
                        <button class="btn-sort" type="button" @click="sortBySum">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td class="order-table--cell order-table--header__cell hidden-xs large-cell">
                      <div class="relative">
                        {{ $t('actionPages.utils.receiver') }}
                        <button class="btn-sort" type="button" @click="sortByReceiver">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td
                      class="order-table--cell order-table--header__cell responsive-width medium-cell"
                    >
                      <div class="relative">
                        {{ $t('actionPages.utils.status') }}
                        <button class="btn-sort" type="button" @click="sortByStatus">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td class="order-table--cell order-table--header__cell hidden-xs medium-cell">
                      <div class="relative">
                        {{ $t('actionPages.utils.date') }}
                        <button class="btn-sort" type="button" @click="sortByTime">
                          <span class="rbi rbi-sort" />
                        </button>
                      </div>
                    </td>
                    <td
                      class="order-table--cell order-table--header__cell text-center bdtop-r visible-td-xs"
                    >
                      <span class="rbi rbi-sort" />
                    </td>
                  </tr>
                  <template v-for="(item, index) in displayedGifts">
                    <tr
                      :key="`gifts-item-x-${index}`"
                      :class="{ open: item.open }"
                      class="order-table--row body d-none d-lg-table-row visible-lg"
                    >
                      <td class="order-table--cell gift-cell medium-cell hidden-xs">
                        {{ item.gift_send.id }}
                      </td>
                      <td class="order-table--cell gift-cell large-cell hidden-xs">
                        <div class="cell-flex clearfix">
                          <div class="item pull-left">
                            <img :alt="item.gift.name" :src="item.gift.photo" class="gift-image" />
                          </div>
                          <div class="item pull-left cell-text">
                            <p>{{ item.gift.name }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="order-table--cell gift-cell small-cell hidden-xs">
                        {{ item.gift_send.old_price + item.gift_send.old_delivery_price }}
                        <span v-if="item.payment_status !== 0" class="rbi" style="font-size: medium"
                          >€</span
                        >
                        <span v-show="item.payment_status === 0" class="rbi rbi-money" />
                      </td>
                      <td class="order-table--cell gift-cell small-cell hidden-xs">
                        {{ item.gift_send.amount }}
                      </td>
                      <td class="order-table--cell gift-cell small-cell hidden-xs">
                        {{
                          item.gift_send.amount *
                          (item.gift_send.old_price + item.gift_send.old_delivery_price)
                        }}
                        <span v-if="item.payment_status !== 0" class="rbi" style="font-size: medium"
                          >€</span
                        >
                        <span v-else class="rbi rbi-money" />
                      </td>
                      <td class="order-table--cell gift-cell large-cell hidden-xs">
                        <div class="item-cell">
                          <div class="wrap_img">
                            <img
                              :alt="item.gift_send.receiver.name + $t('shared.alts.ava')"
                              :src="item.gift_send.receiver.avatar.small"
                            />
                          </div>
                          <div class="info-receiver">
                            <p>{{ item.gift_send.receiver.name }}</p>
                            <p>ID: {{ item.gift_send.receiver.user_id }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="order-table--cell gift-cell hidden-xs medium-cell">
                        <status-template
                          :class="{
                            delivered: item.status === 'accept' || item.status === 'payed',
                            open: item.open,
                            reject: item.status === 'rejected',
                          }"
                          style="display: flex; justify-content: center"
                          :show-icon="true"
                          :status="item.status"
                          class="toggle"
                          @click.native="
                            item.status !== 'not_payed'
                              ? (item.open = !item.open)
                              : (item.open = item.open)
                          "
                        />
                        <rb-button
                          v-show="item.status === 'not_payed'"
                          style="width: 80px; height: 40px; margin: 7px auto"
                          class="btn-outline"
                          @click.native="
                            previewSendGift(true, item.gift_send.receiver.user_id, {
                              id: item.gift_send.id,
                              gift_id: item.gift_send.gift_id,
                              amount: item.gift_send.amount,
                            })
                          "
                        >
                          Retry
                        </rb-button>
                      </td>
                      <td class="order-table--cell gift-cell hidden-xs medium-cell">
                        {{ displayDate(item.gift_send.time_create) }}
                      </td>
                    </tr>
                    <tr :key="`gifts-item-y-${index}`" :class="{ 'open-tr': item.open }">
                      <td class="mask-tr" colspan="8">
                        <div class="responsive-gift-item">
                          <div class="flex-row header-row d-lg-none">
                            <div class="receiver-info-item">
                              <div class="wrap_img">
                                <img
                                  :alt="item.gift_send.receiver.name + $t('shared.alts.ava')"
                                  :src="item.gift_send.receiver.avatar.small"
                                />
                              </div>
                              <div class="col">
                                <p>{{ item.gift_send.receiver.name }}</p>
                                <p>ID: {{ item.gift_send.receiver.user_id }}</p>
                              </div>
                            </div>
                            <div class="serial-info-item">
                              <div class="item">
                                <span class="text-black"
                                  >{{ $t('actionPages.utils.serialNumber') }}:
                                </span>
                                <span>{{ item.gift_send.id }}</span>
                              </div>
                              <div class="item">
                                <span class="text-black">{{ $t('actionPages.utils.date') }}:</span>
                                <span>{{ displayDate(item.gift_send.time_create) }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="flex-row bordered d-lg-none">
                            <div class="gift-info-item">
                              <div class="item">
                                <img
                                  :alt="item.gift.name"
                                  :src="setPhotoSource(item.gift.photo)"
                                  class="gift-image"
                                />
                              </div>
                              <div class="item">
                                <p>{{ item.gift.name }}</p>
                                <div class="wrap info-reciever">
                                  <span v-show="item.payment_status === 0" class="rbi rbi-money" />
                                  <span
                                    >{{
                                      item.gift_send.old_price + item.gift_send.old_delivery_price
                                    }}
                                    <span
                                      v-show="item.payment_status !== 0"
                                      class="rbi"
                                      style="font-size: medium"
                                      >€</span
                                    >
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="price-info-item">
                              <div class="item">
                                <p class="text-black">{{ $t('actionPages.utils.quantityS') }}:</p>
                                <p>{{ item.gift_send.amount }}</p>
                              </div>
                              <div class="item">
                                <p class="text-black">{{ $t('actionPages.utils.total') }}:</p>
                                <div class="item">
                                  <span v-show="item.payment_status === 0" class="rbi rbi-money" />
                                  <p>
                                    {{
                                      item.gift_send.amount *
                                      (item.gift_send.old_price + item.gift_send.old_delivery_price)
                                    }}
                                    <span
                                      v-show="item.payment_status !== 0"
                                      class="rbi"
                                      style="font-size: medium"
                                      >€</span
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="delivery-full">
                            <p
                              v-if="item.open && item.status === 'rejected'"
                              class="alert alert-info"
                            >
                              {{ $t('actionPages.errors.errGift', [item.gift_send.receiver.name]) }}
                            </p>
                            <div
                              v-if="item.open && item.status !== 'rejected'"
                              :class="{ delivered: item.status === 'accept' }"
                              class="delivery-full__shape"
                            >
                              <div class="delivery-full--item finished">
                                <p>{{ $t('gifts.pack') }}</p>
                                <div
                                  v-if="item.status !== 'packaging'"
                                  class="delivery-full--item__dot"
                                >
                                  <div class="delivery-full--item__dot__inner" />
                                </div>
                                <div v-else class="delivery-full--item__current">
                                  <svg
                                    height="32"
                                    version="1.1"
                                    viewBox="0 0 37 32"
                                    width="37"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M24.615 31.385c0 0.34-0.276 0.615-0.615 0.615h-1.231c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h1.231c0.34 0 0.615 0.276 0.615 0.615zM36.923 31.385c0 0.34-0.276 0.615-0.615 0.615h-9.846c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h9.846c0.34 0 0.615 0.276 0.615 0.615zM19.692 31.385c0 0.34-0.276 0.615-0.615 0.615h-6.154c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h6.154c0.34 0 0.615 0.276 0.615 0.615zM9.846 31.385c0 0.34-0.276 0.615-0.615 0.615h-8.615c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h8.615c0.34 0 0.615 0.276 0.615 0.615zM1.231 19.077c0-0.34 0.276-0.615 0.615-0.615h1.748l-0.26-1.756c-0.050-0.336 0.182-0.649 0.518-0.699 0.338-0.047 0.65 0.182 0.7 0.518l0.287 1.937h4.392c0.34 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615h-7.385c-0.34 0-0.615-0.276-0.615-0.615zM1.846 13.538h0.959l-0.26-1.756c-0.050-0.336 0.182-0.649 0.518-0.699 0.338-0.047 0.65 0.182 0.699 0.518l0.288 1.937h5.18c0.34 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615h-7.385c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615zM9.231 25.846c-0.339 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615c0.339 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615zM9.231 23.385c-1.018 0-1.846 0.828-1.846 1.846s0.828 1.846 1.846 1.846c1.018 0 1.846-0.828 1.846-1.846s-0.828-1.846-1.846-1.846zM30.154 25.846c-0.339 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615c0.339 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615zM30.154 23.385c-1.018 0-1.846 0.828-1.846 1.846s0.828 1.846 1.846 1.846c1.018 0 1.846-0.828 1.846-1.846s-0.828-1.846-1.846-1.846zM30.154 28.308c-1.697 0-3.077-1.38-3.077-3.077s1.38-3.077 3.077-3.077c1.697 0 3.077 1.38 3.077 3.077s-1.38 3.077-3.077 3.077zM36.127 15.565l-1.687-1.687-0.594-7.109c0-1.697-1.38-3.077-3.077-3.077h-4.308c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h4.308c1.001 0 1.846 0.846 1.848 1.897l0.56 6.718h-2.028l0.786-1.571c0.152-0.304 0.028-0.673-0.276-0.826s-0.673-0.028-0.826 0.276l-1.060 2.121h-3.312c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h7.13l1.666 1.666c0.351 0.351 0.434 1.158 0.435 1.411v6.769h-1.28c-0.3-2.084-2.092-3.692-4.258-3.692-2.375 0-4.308 1.932-4.308 4.308s1.932 4.308 4.308 4.308c2.166 0 3.959-1.608 4.258-3.692h1.895c0.34 0 0.615-0.276 0.615-0.615v-7.385c0-0.152-0.022-1.508-0.796-2.281zM9.231 28.308c-1.697 0-3.077-1.38-3.077-3.077s1.38-3.077 3.077-3.077c1.697 0 3.077 1.38 3.077 3.077s-1.38 3.077-3.077 3.077zM24 0h-19.692c-1.697 0-3.077 1.38-3.077 3.077 0 0.031 0.002 0.061 0.007 0.091l0.817 5.447h-1.439c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h8.615c0.34 0 0.615-0.276 0.615-0.615s-0.276-0.615-0.615-0.615h-5.932l-0.837-5.581c0.023-0.998 0.842-1.804 1.846-1.804h19.077v23.385h-9.895c-0.3-2.084-2.092-3.692-4.258-3.692-2.375 0-4.308 1.932-4.308 4.308s1.932 4.308 4.308 4.308c2.166 0 3.959-1.608 4.258-3.692h10.511c0.34 0 0.615-0.276 0.615-0.615v-24.615c0-0.34-0.276-0.615-0.615-0.615z"
                                    />
                                  </svg>
                                </div>
                                <p class="text-muted">
                                  {{ getCreatedDate(item.gift_send.time_create) }}
                                </p>
                              </div>
                              <div
                                :class="{
                                  finished: item.status === 'on_way' || item.status === 'accept',
                                }"
                                class="delivery-full--item"
                              >
                                <p>{{ $t('gifts.progress') }}</p>
                                <div
                                  v-if="item.status !== 'on_way'"
                                  class="delivery-full--item__dot"
                                >
                                  <div class="delivery-full--item__dot__inner" />
                                </div>
                                <div v-else class="delivery-full--item__current">
                                  <svg
                                    height="32"
                                    version="1.1"
                                    viewBox="0 0 37 32"
                                    width="37"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M24.615 31.385c0 0.34-0.276 0.615-0.615 0.615h-1.231c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h1.231c0.34 0 0.615 0.276 0.615 0.615zM36.923 31.385c0 0.34-0.276 0.615-0.615 0.615h-9.846c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h9.846c0.34 0 0.615 0.276 0.615 0.615zM19.692 31.385c0 0.34-0.276 0.615-0.615 0.615h-6.154c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h6.154c0.34 0 0.615 0.276 0.615 0.615zM9.846 31.385c0 0.34-0.276 0.615-0.615 0.615h-8.615c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h8.615c0.34 0 0.615 0.276 0.615 0.615zM1.231 19.077c0-0.34 0.276-0.615 0.615-0.615h1.748l-0.26-1.756c-0.050-0.336 0.182-0.649 0.518-0.699 0.338-0.047 0.65 0.182 0.7 0.518l0.287 1.937h4.392c0.34 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615h-7.385c-0.34 0-0.615-0.276-0.615-0.615zM1.846 13.538h0.959l-0.26-1.756c-0.050-0.336 0.182-0.649 0.518-0.699 0.338-0.047 0.65 0.182 0.699 0.518l0.288 1.937h5.18c0.34 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615h-7.385c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615zM9.231 25.846c-0.339 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615c0.339 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615zM9.231 23.385c-1.018 0-1.846 0.828-1.846 1.846s0.828 1.846 1.846 1.846c1.018 0 1.846-0.828 1.846-1.846s-0.828-1.846-1.846-1.846zM30.154 25.846c-0.339 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615c0.339 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615zM30.154 23.385c-1.018 0-1.846 0.828-1.846 1.846s0.828 1.846 1.846 1.846c1.018 0 1.846-0.828 1.846-1.846s-0.828-1.846-1.846-1.846zM30.154 28.308c-1.697 0-3.077-1.38-3.077-3.077s1.38-3.077 3.077-3.077c1.697 0 3.077 1.38 3.077 3.077s-1.38 3.077-3.077 3.077zM36.127 15.565l-1.687-1.687-0.594-7.109c0-1.697-1.38-3.077-3.077-3.077h-4.308c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h4.308c1.001 0 1.846 0.846 1.848 1.897l0.56 6.718h-2.028l0.786-1.571c0.152-0.304 0.028-0.673-0.276-0.826s-0.673-0.028-0.826 0.276l-1.060 2.121h-3.312c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h7.13l1.666 1.666c0.351 0.351 0.434 1.158 0.435 1.411v6.769h-1.28c-0.3-2.084-2.092-3.692-4.258-3.692-2.375 0-4.308 1.932-4.308 4.308s1.932 4.308 4.308 4.308c2.166 0 3.959-1.608 4.258-3.692h1.895c0.34 0 0.615-0.276 0.615-0.615v-7.385c0-0.152-0.022-1.508-0.796-2.281zM9.231 28.308c-1.697 0-3.077-1.38-3.077-3.077s1.38-3.077 3.077-3.077c1.697 0 3.077 1.38 3.077 3.077s-1.38 3.077-3.077 3.077zM24 0h-19.692c-1.697 0-3.077 1.38-3.077 3.077 0 0.031 0.002 0.061 0.007 0.091l0.817 5.447h-1.439c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h8.615c0.34 0 0.615-0.276 0.615-0.615s-0.276-0.615-0.615-0.615h-5.932l-0.837-5.581c0.023-0.998 0.842-1.804 1.846-1.804h19.077v23.385h-9.895c-0.3-2.084-2.092-3.692-4.258-3.692-2.375 0-4.308 1.932-4.308 4.308s1.932 4.308 4.308 4.308c2.166 0 3.959-1.608 4.258-3.692h10.511c0.34 0 0.615-0.276 0.615-0.615v-24.615c0-0.34-0.276-0.615-0.615-0.615z"
                                    />
                                  </svg>
                                </div>
                              </div>
                              <div
                                :class="{ finished: item.status === 'accept' }"
                                class="delivery-full--item"
                              >
                                <p>{{ $t('gifts.success') }}</p>
                                <div
                                  v-if="item.status !== 'accept'"
                                  class="delivery-full--item__dot"
                                >
                                  <div class="delivery-full--item__dot__inner" />
                                </div>
                                <div
                                  v-if="item.status === 'accept'"
                                  class="delivery-full--item__current"
                                >
                                  <svg
                                    height="32"
                                    version="1.1"
                                    viewBox="0 0 37 32"
                                    width="37"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M24.615 31.385c0 0.34-0.276 0.615-0.615 0.615h-1.231c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h1.231c0.34 0 0.615 0.276 0.615 0.615zM36.923 31.385c0 0.34-0.276 0.615-0.615 0.615h-9.846c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h9.846c0.34 0 0.615 0.276 0.615 0.615zM19.692 31.385c0 0.34-0.276 0.615-0.615 0.615h-6.154c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h6.154c0.34 0 0.615 0.276 0.615 0.615zM9.846 31.385c0 0.34-0.276 0.615-0.615 0.615h-8.615c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615h8.615c0.34 0 0.615 0.276 0.615 0.615zM1.231 19.077c0-0.34 0.276-0.615 0.615-0.615h1.748l-0.26-1.756c-0.050-0.336 0.182-0.649 0.518-0.699 0.338-0.047 0.65 0.182 0.7 0.518l0.287 1.937h4.392c0.34 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615h-7.385c-0.34 0-0.615-0.276-0.615-0.615zM1.846 13.538h0.959l-0.26-1.756c-0.050-0.336 0.182-0.649 0.518-0.699 0.338-0.047 0.65 0.182 0.699 0.518l0.288 1.937h5.18c0.34 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615h-7.385c-0.34 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615zM9.231 25.846c-0.339 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615c0.339 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615zM9.231 23.385c-1.018 0-1.846 0.828-1.846 1.846s0.828 1.846 1.846 1.846c1.018 0 1.846-0.828 1.846-1.846s-0.828-1.846-1.846-1.846zM30.154 25.846c-0.339 0-0.615-0.276-0.615-0.615s0.276-0.615 0.615-0.615c0.339 0 0.615 0.276 0.615 0.615s-0.276 0.615-0.615 0.615zM30.154 23.385c-1.018 0-1.846 0.828-1.846 1.846s0.828 1.846 1.846 1.846c1.018 0 1.846-0.828 1.846-1.846s-0.828-1.846-1.846-1.846zM30.154 28.308c-1.697 0-3.077-1.38-3.077-3.077s1.38-3.077 3.077-3.077c1.697 0 3.077 1.38 3.077 3.077s-1.38 3.077-3.077 3.077zM36.127 15.565l-1.687-1.687-0.594-7.109c0-1.697-1.38-3.077-3.077-3.077h-4.308c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h4.308c1.001 0 1.846 0.846 1.848 1.897l0.56 6.718h-2.028l0.786-1.571c0.152-0.304 0.028-0.673-0.276-0.826s-0.673-0.028-0.826 0.276l-1.060 2.121h-3.312c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h7.13l1.666 1.666c0.351 0.351 0.434 1.158 0.435 1.411v6.769h-1.28c-0.3-2.084-2.092-3.692-4.258-3.692-2.375 0-4.308 1.932-4.308 4.308s1.932 4.308 4.308 4.308c2.166 0 3.959-1.608 4.258-3.692h1.895c0.34 0 0.615-0.276 0.615-0.615v-7.385c0-0.152-0.022-1.508-0.796-2.281zM9.231 28.308c-1.697 0-3.077-1.38-3.077-3.077s1.38-3.077 3.077-3.077c1.697 0 3.077 1.38 3.077 3.077s-1.38 3.077-3.077 3.077zM24 0h-19.692c-1.697 0-3.077 1.38-3.077 3.077 0 0.031 0.002 0.061 0.007 0.091l0.817 5.447h-1.439c-0.34 0-0.615 0.276-0.615 0.615s0.276 0.615 0.615 0.615h8.615c0.34 0 0.615-0.276 0.615-0.615s-0.276-0.615-0.615-0.615h-5.932l-0.837-5.581c0.023-0.998 0.842-1.804 1.846-1.804h19.077v23.385h-9.895c-0.3-2.084-2.092-3.692-4.258-3.692-2.375 0-4.308 1.932-4.308 4.308s1.932 4.308 4.308 4.308c2.166 0 3.959-1.608 4.258-3.692h10.511c0.34 0 0.615-0.276 0.615-0.615v-24.615c0-0.34-0.276-0.615-0.615-0.615z"
                                    />
                                  </svg>
                                </div>
                                <p v-if="item.gift_send.time_delivered" class="text-muted">
                                  {{ getDeliveredDate(item.gift_send.time_delivered) }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="flex-row delivery-row d-lg-none">
                            <div class="item">
                              <p>{{ $t('actionPages.utils.status') }}:</p>
                              <span>
                                <status-template :show-icon="false" :status="item.status" />
                              </span>
                            </div>
                            <rb-button
                              v-show="item.status === 'not_payed'"
                              style="width: 80px; height: 40px; margin: 7px auto"
                              class="btn-outline"
                              @click.native="
                                previewSendGift(true, item.gift_send.receiver.user_id, {
                                  id: item.gift_send.id,
                                  gift_id: item.gift_send.gift_id,
                                  amount: item.gift_send.amount,
                                })
                              "
                            >
                              Retry
                            </rb-button>
                            <div
                              v-show="item.payment_status !== 1"
                              :class="{ opened: item.open }"
                              class="item more"
                              @click="item.open = !item.open"
                            >
                              <span>{{ $t('actionPages.utils.more') }}</span>
                              <span class="rbi rbi-down-arrow" />
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
            </template>
            <div v-show="isSearching && !searchResult.length" class="alert-actions-wrap">
              <p class="alert alert-warning">
                {{ $t('actionPages.errors.noSearchResults') }}
              </p>
            </div>
            <div
              v-show="gifts.length < 1 && preloadPage === false && !isSearching"
              class="alert-actions-wrap"
            >
              <div class="alert alert-info">
                <p>{{ $t('actionPages.errors.noGifts') }}</p>
              </div>
            </div>
            <div v-show="preloadPage" class="alert-actions-wrap">
              <div class="loader--wrap">
                <div class="loader" />
              </div>
            </div>
            <lazy-load v-show="displayLoadMoreBtn" :counter="20" @click.native="limit += limit" />
          </div>
        </tab>
      </tabs>
      <div v-if="preloadPage" class="loader--wrap">
        <div class="loader" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import statusTemplate from './myGifts/template.vue';
import { PHOTO_SRC } from '../../mixins/utils';
import LazyLoad from './parts/LoadMore.vue';
import RbButton from '../Button';
import {
  ACTIONS_DATA,
  CHECK_PRIVILEGES,
  COMPARE_DATA,
  USER_ACTIONS,
} from '../../mixins/userActions';
import { MAIL_MODAL, PREVIEW_MODAL, REGISTRATION_MODAL } from '../../mixins/formsActions';

export default {
  components: {
    statusTemplate,
    LazyLoad,
    RbButton,
  },
  mixins: [
    PHOTO_SRC,
    USER_ACTIONS,
    ACTIONS_DATA,
    CHECK_PRIVILEGES,
    MAIL_MODAL,
    PREVIEW_MODAL,
    REGISTRATION_MODAL,
    COMPARE_DATA,
  ],
  data() {
    return {
      options: [
        {
          k: '',
          v: this.$t('mail.sort.default'),
        },
        {
          k: 'payed',
          v: this.$t('gifts.payed'),
        },
        {
          k: 'not_payed',
          v: this.$t('gifts.notPayed'),
        },
        {
          k: 'packaging',
          v: this.$t('gifts.pack'),
        },
        {
          k: 'on_way',
          v: this.$t('gifts.progress'),
        },
        {
          k: 'accept',
          v: this.$t('gifts.success'),
        },
        {
          k: 'rejected',
          v: this.$t('gifts.reject'),
        },
      ],
      myGifts: [],
      searchBy: true,
      showStatus: false,
      nonCategory: {},
      storedGifts: [],
      searchResult: [],
      defaultLimit: 20,
      limit: 20,
      sorting: '',
      isSearching: false,
      preloadPage: true,
      searchName: '',
      searchType: { k: '', v: this.$t('mail.sort.default') },
      loading: false,
      vGiftCount: 0,
      sortState: {
        time: false,
        receiver: false,
        summ: false,
        quantity: false,
        action: false,
        id: false,
        serial: false,
        price: false,
        name: false,
        giftName: false,
      },
    };
  },
  computed: {
    titleMy() {
      return `<span>${this.$t('actionPages.titles.received_gift')} <span
                class="count">(${this.vGiftCount})</span></span>`;
    },
    titleMe() {
      return `<span>${this.$t('actionPages.titles.sent_gift')} <span class="count">(${
        this.gifts.length
      })</span></span>`;
    },

    user() {
      return this.$store.getters.user;
    },
    /**
     * Показывать ли кнопку "загрузить еще"
     *
     * @return {boolean}
     */
    displayLoadMoreBtn() {
      if (this.isSearching) {
        return this.displayedGifts.length < this.searchResult.length;
      }
      if (this.vGiftCount > this.limit) {
        return this.vGiftCount > this.limit;
      }
      return this.displayedGifts.length < this.storedGifts.length;
    },

    displayLoadMoreBtn2() {
      return this.vGiftCount > this.limit;
    },
    sex() {
      return this.$store.getters.sex;
    },
    gifts: {
      get() {
        return this.storedGifts;
      },
      set(val) {
        val.forEach((i) => (i.open = false));
        this.storedGifts = val;
      },
    },

    /**
     * Выбрать показываемые записи: результаты поиска или обычный список
     *
     * @return {array}
     */
    displayedGifts() {
      return this.isSearching ? this.searchResult : this.gifts;
    },

    /**
     * Получить ограниченное кол-во показываемых подарков
     *
     * @return {array}
     */
    limited() {
      return this.displayedGifts.slice(0, this.limit);
    },
  },
  watch: {
    /**
     * Получить список подарков при получении своего профиля
     */

    sex() {
      if (this.sex.isMan) {
        this.getGifts();
      } else {
        this.preventEnter();
      }
    },
    /**
     * Поиск среди пользователей по имени или ИД
     *
     * @param val {string}
     */
    searchName(val) {
      if (val.length) {
        this.isSearching = true;
        const self = this;
        setTimeout(() => {
          self.search();
        });
      } else {
        this.searchResult = [];
        this.isSearching = false;
      }
    },

    /**
     * Отфильтровать данные по имени получателя или его ИД
     *
     * @param val
     */
    searchType(val) {
      if (val) {
        this.isSearching = true;
        const self = this;
        setTimeout(() => {
          self.search();
        });
      } else {
        this.searchResult = [];
        this.isSearching = false;
      }
    },
  },

  mounted() {
    document.title = this.$t('actionPages.titles.gifts');
  },
  methods: {
    markViewed(id, all, condition, data, refresh) {
      const postData = {
        mark_all: all ? 1 : 0,
        id,
      };
      if (id) {
        delete postData.mark_all;
      } else {
        delete postData.id;
      }
      if (condition) {
        this.$http
          .post('v1/virtual-gift/mark', {
            access_token: window.localStorage['access-token'],
            ...postData,
          })
          .then(() => {
            this.$store.dispatch('getCounters', {});
            if (id) {
              data.seen = +new Date();
            } else if (refresh) {
              this.myGifts.forEach((gift, index, arr) => {
                gift.virtual_gift_sent.seen = 1;
                this.$set(arr, index, gift);
              }, this);
            }
          });
      }
    },
    tabChanged(selectedTab) {
      if (selectedTab.tab.id === 'my') {
        this.searchBy = true;
      } else {
        this.searchBy = false;
      }
    },

    loadMore() {
      this.limit += this.limit;

      this.loadGifts();
    },
    /**
     * Узнать статус доставки, основываясь на статусах агенства и сервиса
     *
     * @param agency {string}
     * @param site {string}
     * @return {string}
     */
    compareStatus(agency, site, paymentStatus) {
      if (paymentStatus === 0) {
        if (agency === 'free' && agency === site) {
          return 'packaging';
        }
        if (agency === 'reject') {
          return 'rejected';
        }
        if (site === 'reject') {
          return 'on_way';
        }
        if (agency === 'accept' && agency === site) {
          return 'accept';
        }
        if (agency === 'accept' && site !== 'reject') {
          return 'on_way';
        }
      } else if (paymentStatus === 2) {
        if (agency === 'free' && agency === site) {
          return 'packaging';
        }
        if (agency === 'reject') {
          return 'rejected';
        }
        if (site === 'reject') {
          return 'on_way';
        }
        if (agency === 'accept' && agency === site) {
          return 'accept';
        }
        if (agency === 'accept' && site !== 'reject') {
          return 'on_way';
        }
      } else {
        return 'not_payed';
      }
    },

    /**
     * Отсортировать данные по серийному номеру
     */
    sortBySerial() {
      this.sortState.serial = !this.sortState.serial;
      const self = this;
      const sort = function (a, b) {
        if (self.sortState.serial) {
          return a.gift_send.id - b.gift_send.id;
        }
        return a.gift_send.id > b.gift_send.id ? -1 : 1;
      };
      this.searchResult.length ? this.searchResult.sort(sort) : this.storedGifts.sort(sort);
    },
    /**
     * Отсортировать данные по имени
     */
    sortByName() {
      const self = this;
      this.sortState.name = !this.sortState.name;
      const sort = function (a, b) {
        const textA = a.gift.name.toLowerCase().trim();
        const textB = b.gift.name.toLowerCase().trim();
        if (self.sortState.name) {
          return textA > textB ? 1 : -1;
        }
        return textA > textB ? -1 : 1;
      };
      this.isSearching ? this.searchResult.sort(sort) : this.displayedGifts.sort(sort);
    },
    /**
     * Отсортировать данные по цене
     */
    sortByPrice() {
      this.sortState.price = !this.sortState.price;
      const self = this;
      const sort = function (a, b) {
        const priceA = a.gift_send.old_price + a.gift_send.old_delivery_price;
        const priceB = b.gift_send.old_price + b.gift_send.old_delivery_price;
        if (self.sortState.price) {
          return priceA - priceB;
        }
        return priceA > priceB ? -1 : 1;
      };
      this.searchResult.length ? this.searchResult.sort(sort) : this.storedGifts.sort(sort);
    },
    /**
     * Отсортировать данные по количеству
     */
    sortByQuantity() {
      this.sortState.quantity = !this.sortState.quantity;
      const self = this;
      const sort = function (a, b) {
        if (self.sortState.quantity) {
          return a.gift_send.amount - b.gift_send.amount;
        }
        return a.gift_send.amount > b.gift_send.amount ? -1 : 1;
      };
      this.isSearching.length ? this.searchResult.sort(sort) : this.storedGifts.sort(sort);
    },
    /**
     * Отсортировать данные по сумме кредитов
     */
    sortBySum() {
      this.sortState.summ = !this.sortState.summ;
      const self = this;

      const sort = function (a, b) {
        const first = a.gift_send.amount * (a.gift_send.old_price + a.gift_send.old_delivery_price);
        const second =
          b.gift_send.amount * (b.gift_send.old_price + b.gift_send.old_delivery_price);
        if (self.sortState.summ) {
          return first - second;
        }
        return first > second ? -1 : 1;
      };
      this.searchResult.length ? this.searchResult.sort(sort) : this.storedGifts.sort(sort);
    },
    /**
     * Отсортировать данные по получателю
     */
    sortByReceiver() {
      const self = this;
      this.sortState.receiver = !this.sortState.receiver;
      const sort = function (a, b) {
        const textA = a.gift_send.receiver.user_id;
        const textB = b.gift_send.receiver.user_id;
        if (self.sortState.receiver) {
          return textA - textB;
        }
        return textA > textB ? -1 : 1;
      };
      this.searchResult.length ? this.searchResult.sort(sort) : this.storedGifts.sort(sort);
    },
    /**
     * Отсортировать данные по статусу доставки
     */
    sortByStatus() {
      const self = this;
      this.sortState.status = !this.sortState.status;
      const sort = function (a, b) {
        const textA = a.status;
        const textB = b.status;
        if (self.sortState.status) {
          return textA > textB ? 1 : -1;
        }
        return textA > textB ? -1 : 1;
      };
      this.searchResult.length ? this.searchResult.sort(sort) : this.storedGifts.sort(sort);
    },
    /**
     * Отсортировать данные по времени создания заказа
     */
    sortByTime() {
      this.sortState.time = !this.sortState.time;
      const self = this;
      const sort = function (a, b) {
        if (self.sortState.time) {
          return a.gift_send.time_create - b.gift_send.time_create;
        }
        return a.gift_send.time_create > b.gift_send.time_create ? -1 : 1;
      };
      this.searchResult.length ? this.searchResult.sort(sort) : this.storedGifts.sort(sort);
    },
    /**
     * Получить понятное представление даты о времени создания заказа
     */
    getCreatedDate(timestamp) {
      return moment(timestamp * 1000).format('MMM Do, YYYY');
    },
    /**
     * Получить понятное представление даты о времени доставки заказа
     */
    getDeliveredDate(timestamp) {
      return moment(timestamp * 1000).format('MMM Do, YYYY');
    },
    /**
     * Открыть детальный просмотр инфы о заказе
     */
    openStatus(item) {
      item.open = true;
    },
    /**
     * Поиск по имени или ИД среди отправителей
     */
    search() {
      let name = this.searchName;
      name = name.toLowerCase();
      this.limit = this.defaultLimit;
      if (this.searchName.length && this.searchType.k.length) {
        this.searchResult = this.storedGifts.filter((item) => {
          const id = `${item.gift_send.receiver.user_id}`;
          if (
            item.gift_send.receiver.name.toLowerCase().includes(name) ||
            (id.includes(name) && item.status === this.searchType.k)
          ) {
            return true;
          }
        });
        return;
      }
      if (this.searchName.length) {
        this.searchResult = this.storedGifts.filter((item) => {
          const id = `${item.gift_send.receiver.user_id}`;
          if (item.gift_send.receiver.name.toLowerCase().includes(name) || id.includes(name)) {
            return true;
          }
        });
        return;
      }
      if (this.searchType.k.length) {
        this.searchResult = this.storedGifts.filter((item) => item.status === this.searchType.k);
        return;
      }
      this.searchResult = this.storedGifts;
    },

    /**
     * Получить список подарков
     */
    getGifts() {
      this.$http
        .post('v1/gift/my', {
          access_token: window.localStorage['access-token'],
        })
        .then((response) => {
          response.body.result.forEach((i) => {
            i.status = this.compareStatus(
              i.gift_send.moderation_agency,
              i.gift_send.moderation_site,
              i.gift_send.payment_status
            );
            i.payment_status = i.gift_send.payment_status;
          }, this);
          this.gifts = response.body.result;

          this.loadGifts();
        });
    },

    loadGifts() {
      this.preloadPage = true;
      this.$http
        .post('v1/virtual-gift/load-received', {
          access_token: window.localStorage['access-token'],
          order_by: 'created_at',
          order_type: 'desc',
          limit: this.limit,
          offset: 0,
        })
        .then((response) => {
          this.vGiftCount = response.body.result.count;
          this.myGifts = response.body.result.list;
          this.preloadPage = false;
        });
    },

    /**
     * Запретить вход женщинам на эту страницу
     */
    preventEnter() {
      if (this.sex.isWoman) {
        this.$router.push({
          name: '404',
        });
      }
    },

    /**
     * Получить строчное представление даты
     * @param timestamp {number}
     * @return {string}
     */
    displayDate(timestamp) {
      return moment(timestamp * 1000).format('MMM Do, YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
@import '../../assets/scss/vars';

.icon {
  font-size: 20px;
}

.gift-table {
  .large-extra-cell {
    width: 25%;
  }

  .large-cell {
    width: 20%;
  }

  .small-cell {
    width: 10%;
  }

  .medium-cell {
    width: 15%;
  }

  .cell-flex,
  .item-cell {
    display: flex;
    align-items: center;

    img {
      width: 40px;
    }

    .cell-text {
      margin-left: 10px;
    }

    p {
      margin-bottom: 0;
    }

    .wrap_img {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        width: 53px;
        height: 53px;
        border: 1px solid transparent;
        border-right-color: $black;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      img {
        width: 45px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
    }
  }

  .body {
    .order-table--cell {
      height: 65px;
    }
  }
}

.received_gifts_grid {
  .alert-actions-wrap {
    margin-bottom: 50px;
  }
}

.nav-tabs > li.active span .count {
  color: #e21919;
}

.count {
  border: none;
}

.received_gifts {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;

  .load-more {
    margin-bottom: 40px;
  }

  .received_gift {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 100%;
    padding: 25px;
    justify-content: space-between;

    background: $light-grey;

    &.not-viewed {
      position: relative;

      &:before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        background: #e21919;
        opacity: 0.1;
        animation: example2 3s infinite ease-in-out;
        z-index: 1;
      }

      &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        background: transparent;
        opacity: 0.3;
        animation: example2 3s infinite ease-in-out;
        animation-delay: 1.5s;
        z-index: 1;
      }

      @keyframes example2 {
        0% {
          opacity: 0.05;
        }
        50% {
          opacity: 0.2;
        }
        100% {
          opacity: 0.05;
        }
      }
    }

    &-col {
      padding: 0 12px;
      width: 50%;
      min-height: 440px;
      margin-bottom: 25px;
    }

    .wrap_img {
      position: relative;
      margin-right: 20px;

      &:after {
        content: '';
        position: absolute;
        width: 53px;
        height: 53px;
        border: 1px solid transparent;
        border-right-color: $black;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      img {
        width: 45px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
    }
  }
}

.gift_sender {
  display: flex;
  align-items: center;
  align-self: flex-start;
}

.wrap_receiv {
  display: flex;
  flex-direction: column;

  .name_receiv {
    color: $black;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.63;
    letter-spacing: 0.8px;
    margin-bottom: 0;
  }
}

span.time_create {
  color: #010101;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.6px;
}

.gift_wrapper {
  margin-top: 40px;
  margin-bottom: 20px;
  width: 75%;

  .gift_photo {
    display: flex;
    justify-content: center;

    img {
      max-height: 165px;
    }
  }

  .comment {
    font-size: 13px;
    color: #7f8288;
    text-align: center;
    margin-top: 30px;
    word-break: break-word;
  }
}

.order-table--wrap {
  padding: 0 0 20px 0;
}

.btn_transparent {
  border: 1px solid #dbe1eb;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  background-color: transparent;
  color: #e21919;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  padding: 15px 55px;

  span {
    display: flex;
    align-items: center;

    svg {
      width: 16px;
      height: 16px;
      fill: #e21919;
      margin-right: 8px;
    }
  }
}

.info-receiver {
  margin-left: 13px;

  p {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1.4px;

    &:last-child {
      font-size: 12px;
      font-weight: 400;
    }
  }
}

.open-tr {
  border-bottom: 1px solid $grey-two;
}

.delivery-full {
  flex: 1 1;
  $bgc: #fafafa;
  $progress: #e1393d;

  .alert {
    margin: 10px 0;
  }

  &__shape {
    display: flex;
    width: 650px;
    height: 173px;
    margin: 23px auto;
    padding: 32px 67px;
    background: url(/static/images/shevron.png) center center no-repeat;
    background-size: contain;
    align-items: center;

    &.delivered {
      .delivery-full--item {
        color: $green;

        &:after {
          background-color: $green !important;
        }

        &__dot {
          background-color: $green !important;
        }

        &__dot__inner {
          border-color: $green !important;
        }
      }
    }
  }

  &--item {
    position: relative;
    flex: 1 1 33%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 80px;

    p {
      position: relative;
      z-index: 15;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 1.4px;
    }

    &.finished {
      color: $red;

      &:after {
        background-color: $red !important;
      }

      .delivery-full--item__dot {
        height: 24px;
        width: 24px;
        background-color: $red;

        &__inner {
          background-color: #fff;
          border-radius: 50%;
          height: 7px;
          width: 7px;
        }
      }
    }

    &:not(:last-of-type):after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%);
      width: 100%;
      height: 2px;
      background-color: #afafaf;
    }

    &__dot,
    &__dot__inner,
    &__current {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
    }

    &__dot {
      height: 24px;
      width: 24px;
      background-color: $grey;
      -webkit-border-radius: 50px;
      -moz-border-radius: 50px;
      border-radius: 50px;
      box-shadow: 0px 0px 0px 10px rgba(246, 246, 246, 1);

      &__inner {
        background-color: #fff;
        border-radius: 50%;
        height: 7px;
        width: 7px;
      }
    }

    &__current {
      height: 40px;
      width: 40px;
      padding: 4px;
      background-color: $light-grey;
      box-shadow: 0px 0px 0px 10px rgba(246, 246, 246, 1);
    }

    svg {
      height: 32px;
      width: 32px;
      fill: currentColor;
    }

    .text-muted {
      color: $black;
      font-size: 14px;
      font-weight: 300;
      letter-spacing: 1.4px;
    }
  }
}

.form-group {
  width: 194px;
  margin-left: 15px;

  .form-control {
    width: 100%;
  }
}

@media only screen and (max-width: 991px) {
  .open-tr {
    border-bottom: none;

    .bordered {
      border-bottom: 1px solid $grey-two;
    }
  }

  .responsive-gift-item {
    border: 1px solid $grey-two;
    margin-bottom: 25px;

    .text-black {
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 1.4px;
    }

    .flex-row {
      display: flex;
      justify-content: space-between;
      padding: 15px 20px;

      &.header-row {
        background: $light-grey;
      }

      .serial-info-item {
        flex: 0 0 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .item {
          display: flex;
          justify-content: space-between;
        }
      }

      .receiver-info-item {
        display: flex;
        flex: 0 0 50%;
        align-items: center;

        .col {
          display: flex;
          flex-direction: column;

          p {
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 1.4px;

            &:last-child {
              font-size: 12px;
              font-weight: 400;
            }
          }
        }

        .wrap_img {
          position: relative;

          &:after {
            content: '';
            position: absolute;
            width: 53px;
            height: 53px;
            border: 1px solid transparent;
            border-right-color: $black;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
          }

          img {
            width: 45px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
          }
        }
      }
    }

    .bordered {
      border-top: 1px solid $grey-two;

      .gift-info-item {
        flex: 0 0 50%;
        display: flex;
        align-items: center;

        .gift-image {
          width: 50px;
          margin-right: 20px;
        }

        .item {
          .info-reciever {
            display: flex;
            align-items: center;
            margin-top: 10px;
          }
        }
      }

      .rbi {
        font-size: 20px;
        margin-right: 10px;
      }

      .price-info-item {
        flex: 0 0 50%;
        display: flex;
        flex-direction: column;

        .item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .coin-icon {
        height: 18px;
        width: 18px;
      }
    }

    .delivery-row {
      border-top: 1px solid $grey-two;

      .item {
        display: flex;
        align-items: center;

        span {
          color: $red;
          margin-left: 5px;
          transition: 0.3s;
        }

        &.more {
          span {
            color: $black;

            &:first-child {
              border-bottom: 1px dashed $black;
            }
          }

          &.opened {
            .rbi {
              transform: scaleY(-1);
            }
          }
        }
      }
    }
  }
  .delivery-full__shape {
    width: 95%;
  }
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
  .icon {
    display: none;
  }

  .form-group {
    width: 48%;
    margin-left: 0;
  }

  .action-page--heading {
    .set-flex {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }

    .action-page--tip {
      width: 100%;
      margin-top: 15px;

      .set-flex {
        flex-direction: row;
        justify-content: space-between;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .responsive-gift-item {
    .flex-row {
      display: flex;
      justify-content: space-between;
      padding: 15px 20px;

      &.header-row {
        background: $light-grey;
        flex-direction: column !important;
      }

      .serial-info-item {
        flex-direction: column;
        justify-content: center;
        padding-left: 60px;
        margin-top: 15px;

        .item {
          justify-content: flex-start;

          span {
            &:last-child {
              margin-left: 5px;
            }
          }
        }
      }
    }

    .bordered {
      flex-direction: column !important;

      .price-info-item {
        flex: 0 0 50%;
        display: flex;
        flex-direction: row;
        margin-top: 15px;

        .item {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 10px;
          flex: 0 0 50%;

          p {
            &:last-child {
              margin-left: 5px;
            }
          }

          .item {
            margin-left: 5px;

            .rbi {
              margin-right: 5px;
            }

            p {
              margin-left: 0;
            }
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .coin-icon {
        height: 18px;
        width: 18px;
      }
    }

    .delivery-row {
      border-top: 1px solid $grey-two;

      .item {
        display: flex;
        align-items: center;

        span {
          color: $red;
          margin-left: 5px;
          transition: 0.3s;
        }

        &.more {
          span {
            color: $black;

            &:first-child {
              border-bottom: 1px dashed $black;
            }
          }

          &.opened {
            .rbi {
              transform: scaleY(-1);
            }
          }
        }
      }
    }
  }

  .received_gifts {
    margin-bottom: 0;

    .received_gift-col {
      width: 100%;
      margin-bottom: 25px;
    }
  }
  .delivery-full {
    flex: 1 1;
    $bgc: #fafafa;
    $progress: #e1393d;

    .alert {
      margin: 10px 0;
    }

    &__shape {
      background: none;
      height: auto;
      width: auto;
      padding: 20px 15px;
      margin: auto;

      &.delivered {
        .delivery-full--item {
          color: $green;

          &:after {
            background-color: $green !important;
          }

          &__dot {
            background-color: $green !important;
          }

          &__dot__inner {
            border-color: $green !important;
          }
        }
      }
    }

    &--item {
      position: relative;
      flex: 1 1 33%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 80px;

      p {
        position: relative;
        z-index: 15;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 1.4px;
        text-align: center;
      }

      &.finished {
        color: $red;

        &:after {
          background-color: $red !important;
        }

        .delivery-full--item__dot {
          height: 18px;
          width: 18px;
          background-color: $red;

          &__inner {
            background-color: #fff;
            border-radius: 50%;
            height: 5px;
            width: 5px;
          }
        }
      }

      &:not(:last-of-type):after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 2px;
        background-color: #afafaf;
      }

      &__dot,
      &__dot__inner,
      &__current {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
      }

      &__dot {
        height: 18px;
        width: 18px;
        background-color: $grey;
        -webkit-border-radius: 50px;
        -moz-border-radius: 50px;
        border-radius: 50px;
        box-shadow: 0px 0px 0px 5px rgba($white, 1);

        &__inner {
          background-color: #fff;
          border-radius: 50%;
          height: 5px;
          width: 5px;
        }
      }

      &__current {
        height: 35px;
        width: 35px;
        padding: 4px;
        background-color: $white;
        box-shadow: 0px 0px 0px 5px rgba($white, 1);
      }

      svg {
        height: 25px;
        width: 25px;
        fill: currentColor;
      }

      .text-muted {
        color: $black;
        font-size: 11px;
        font-weight: 300;
        letter-spacing: 1.4px;
        white-space: nowrap;
      }
    }
  }
}
</style>
